import React from 'react';
import YouTube from '../YouTube';
import dayjs from 'dayjs';
import { Typography } from '@mui/material';
import { Sermon } from '@fosterburg/common-ui/types/Sermon';

interface Props {
  sermon: Sermon;
  width: number;
}

export default function Sermon(props: Props) {
  const date = dayjs(props.sermon.preached_on, 'YYYY-MM-DD HH:mm:ss').format('MMMM D, YYYY');

  const width = props.width ? { maxWidth: props.width } : {};

  return (
    <>
      <Typography variant="h6" style={{ marginLeft: 15, marginRight: 15 }}>
        {!!props.sermon.series?.name ? props.sermon.series?.name + ':' : ''} {props.sermon.title}
      </Typography>
      <Typography variant="subtitle1" style={{ color: '#616161ed', marginLeft: 15 }}>
        {date}
      </Typography>
      <div style={{ textAlign: 'center', margin: 15, ...width }}>
        <YouTube url={props.sermon.video.youtube_id} />
      </div>
      <hr />
    </>
  );
}
